import axios from "axios";
import { useCallback, useEffect, useState } from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;

api.interceptors.response.use(
  (response) => response,
  async (err) => {
    const cfg = err.config || {};
    const url = cfg.url || "";

    if (
      err.response?.status !== 401 ||
      cfg._retry ||
      url.includes("/auth/")
    ) {
      return Promise.reject(err);
    }

    cfg._retry = true;

    try {
      if (!refreshing) {
        refreshing = api.post("/auth/refresh");
      }

      await refreshing;
      return api(cfg);
    } catch (refreshError) {
      return Promise.reject(err);
    } finally {
      refreshing = null;
    }
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!e?.response) return "Unable to reach the server. Please check your connection and try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg || "").replace(/^Value error, /, "")).filter(Boolean).join(" ");
  return "Something went wrong. Please try again.";
}

export function useFetch(url) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const reload = useCallback(async () => {
    if (!url) return;
    setLoading(true);
    try {
      const r = await api.get(url);
      setData(r.data);
      setError(null);
    } catch (e) {
      setError(errMsg(e));
    } finally {
      setLoading(false);
    }
  }, [url]);
  useEffect(() => {
    reload();
  }, [reload]);
  return { data, loading, error, reload, setData };
}

export const emailNote = (s) =>
  ({
    sent: "An email notification was sent.",
    not_configured: "Email notifications are not configured, so no email was sent.",
    skipped_demo: "Demonstration record - no email was sent.",
    failed: "The email notification could not be delivered.",
  }[s] || "");
